/**
 * @module services/prescription-log
 * @description Servicio del log de auditoría de recetas de medicamentos
 *              enviadas a web services externos. Expuesto por
 *              components/prescription-log/route.js en la API.
 *
 *              Solo admin. Cada organización ve únicamente sus registros.
 */
import api from "./api";

const prescriptionLogService = {
  /**
   * @description Listado paginado del log de recetas. Cada registro incluye
   *              el payload enviado (`request`), lo que devolvió el web
   *              service (`response`), el estado y, si hubo error, el motivo.
   * @param {Object} [params] - { status, patient, offset, limit }
   * @param {('success'|'error')} [params.status] - Filtro por resultado
   * @param {string} [params.patient] - Filtro por paciente (ObjectId)
   * @param {number} [params.offset] - Paginación: desde (default 0)
   * @param {number} [params.limit] - Paginación: cantidad (default 25, máx 100)
   * @returns {Promise<{ items: Array, total: number }>}
   */
  list(params = {}) {
    return api.get("/prescription-log", { params });
  },
};

export default prescriptionLogService;
